import type { ThemeConfig } from 'antd';

import { tokens } from './tokens';

export const defaultTheme: ThemeConfig = {
  token: {
    colorLink: tokens.colors.primary,
    colorLinkHover: tokens.colors.primaryHover,
    colorPrimary: tokens.colors.primary,
    colorPrimaryHover: tokens.colors.primaryHover,
    colorPrimaryBg: tokens.colors.primaryLight,
    colorText: tokens.colors.text,
    colorBgContainer: tokens.colors.background,
    colorBorder: tokens.colors.border,
    colorBgTextHover: tokens.colors.backgroundHover,
    colorTextSecondary: tokens.colors.secondaryText,

    fontFamily: tokens.typography.fontFamily,
    fontSize: tokens.typography.fontSize,

    borderRadius: 2,
    controlHeight: 32,

    marginXS: tokens.spacing.xs,
    marginSM: tokens.spacing.sm,
    margin: tokens.spacing.md,
    marginMD: tokens.spacing.md,
    marginLG: tokens.spacing.lg,
    marginXL: tokens.spacing.xl,
  },
  components: {
    Button: {
      borderRadius: 2,
      colorText: tokens.colors.primary,
      colorBorder: tokens.colors.primary,
      colorPrimaryHover: tokens.colors.primaryHover,
      colorBgTextHover: tokens.colors.primaryHover,
    },
    Select: {
      controlHeight: 32,
      borderRadius: 2,
      optionSelectedBg: tokens.colors.menuItemSelectedBg,
    },
    Table: {
      headerBg: tokens.colors.backgroundHover,
      headerColor: tokens.colors.text,
      borderColor: tokens.colors.border,
      fontSize: tokens.typography.fontSize,
      fontFamily: tokens.typography.fontFamily,
    },
    Input: {
      controlHeight: 32,
      borderRadius: 2,
    },
    Modal: {
      borderRadius: 8,
      paddingContentHorizontalLG: 24,
    },
    Tabs: {
      cardBg: tokens.colors.background,
      cardGutter: 12,
      inkBarColor: tokens.colors.primary,
      fontWeightStrong: 700,
      padding: 12,
      borderRadiusLG: 8,
      boxShadow: '0 11px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 10px 0 rgba(0, 0, 0, 0.1)',
      itemSelectedColor: tokens.colors.primary,
      itemHoverColor: tokens.colors.secondaryHover,
      itemColor: tokens.colors.text,
      titleFontSize: tokens.typography.fontSize,
      cardHeight: 40,
      cardPadding: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
    },
    Card: {
      borderRadius: 12,
    },
    Menu: {
      colorBgContainer: tokens.colors.menuBackground,
      itemSelectedBg: tokens.colors.menuItemSelectedBg,
      itemBg: tokens.colors.menuBackground,
      itemColor: tokens.colors.menuText,
      itemHoverColor: tokens.colors.menuText,
      itemSelectedColor: tokens.colors.menuText,
      itemHoverBg: tokens.colors.menuItemSelectedBg,
      subMenuItemBg: tokens.colors.menuBackground,
      colorText: tokens.colors.menuText,
      popupBg: tokens.colors.menuBackground,
      itemActiveBg: tokens.colors.menuItemSelectedBg,
      darkItemSelectedBg: tokens.colors.menuItemSelectedBg,
      darkSubMenuItemBg: tokens.colors.menuBackground,
      fontWeightStrong: tokens.typography.fontWeights.bold,
    },
  },
};
